import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      // Redirect to the page they were trying to access, or default to mine-fester
      const from = (location.state as any)?.from;
      if (from) {
        navigate(from.pathname + from.search, { replace: true });
      } else {
        navigate('/deltaker/mine-fester');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Innlogging feilet');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Logg inn</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">E-post</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Passord</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={isLoading}>
            {isLoading ? 'Logger inn...' : 'Logg inn'}
          </button>
        </form>
        <div style={{ marginTop: 'var(--spacing-md)', textAlign: 'center' }}>
          <Link to="/glemt-passord">Glemt passord?</Link>
          <br />
          <Link to="/opprett-konto">Har du ikke konto? Opprett konto</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
